module.exports = __webpack_public_path__ + "static/img/2-6.2f58d961.png";